import { AppState } from '../reducers/root';
import { ReviewState } from '../slices/review';

export const getIsOpen = (state: AppState): ReviewState['isOpen'] =>
  state.review.isOpen;

export const getTemplate = (state: AppState): ReviewState['template'] =>
  state.review.template;

export const getData = (state: AppState): ReviewState['data'] =>
  state.review.data;

export const getVariables = (state: AppState): ReviewState['variables'] =>
  state.review.variables;

export const getEvents = (state: AppState): ReviewState['events'] =>
  state.review.events;

export const getNextAction = (state: AppState): ReviewState['nextAction'] =>
  state.review.nextAction;

export const getDatasetId = (state: AppState): ReviewState['datasetId'] =>
  state.review.datasetId;

export const getParseDates = (state: AppState): ReviewState['parseDates'] =>
  state.review.parseDates;
